import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import img1 from '../../../assets/images/hero_banner.png';

const AboutUs = () => {
  const milestones = [
    { year: '2012', title: 'The Foundation', desc: 'Started as a small computer software consultation service in J.P. Nagar, Bangalore.' },
    { year: '2016', title: 'Enterprise Services', desc: 'Expanded into corporate deployments and system builder license audits.' },
    { year: '2021', title: 'E-Store Launch', desc: 'Launched online distribution of certified retail and OEM Microsoft license keys.' },
    { year: '2026', title: 'Trusted Partner', desc: 'Trusted by over 50,000+ satisfied clients with genuine keys and instant delivery.' },
  ];

  return (
    <Box>
      {/* Hero */}
      <Box sx={{ py: 12, backgroundColor: '#0e6ada', color: '#FFF', textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h2" gutterBottom sx={{ color: '#ffffffff !important' }}>Our Story</Typography>
          <Typography variant="h5" sx={{ fontWeight: 400, opacity: 0.9, color: '#ffffffff !important' }}>
            For over 14 years, AR Infotech has been providing verified digital software licenses and technical support to individuals and enterprises alike.
          </Typography>
        </Container>
      </Box>

      {/* Narrative */}
      <Container maxWidth="lg" sx={{ py: 10 }}>
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={img1}
              sx={{ width: '100%', borderRadius: 1, boxShadow: '20px 20px 0px #F8FAFC' }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" gutterBottom>A Legacy of Trust</Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              At AR Infotech, we believe that access to genuine, licensed software is fundamental to security, stability, and productivity. We help clients navigate complex licensing systems with complete transparency.
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              We source our licenses directly from authorized Microsoft partner channels, guaranteeing original activation keys at highly competitive prices. Every purchase is backed by our instant delivery commitment and dedicated lifetime customer support.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* Timeline */}
      <Box sx={{ py: 10, backgroundColor: '#F8FAFC' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" align="center" gutterBottom sx={{ mb: 8 }}>Our Journey</Typography>
          <Grid container spacing={4}>
            {milestones.map((m, i) => (
              <Grid item xs={12} sm={6} md={3} key={i} sx={{ display: 'flex' }}>
                <motion.div whileHover={{ y: -10 }} style={{ height: '100%', width: '100%' }}>
                  <Card sx={{ height: '100%', textAlign: 'center', p: 2, borderRadius: 1, display: 'flex', flexDirection: 'column' }}>
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography variant="h2" color="#0e6ada" sx={{ fontWeight: 800, opacity: 0.1, mt: -2 }}>{m.year}</Typography>
                      <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 2 }}>{m.title}</Typography>
                      <Typography variant="body2" color="text.secondary">{m.desc}</Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default AboutUs;
